import http from '@/shared/api/http'

export async function uploadImage(file, type = 'products') {
  const formData = new FormData()
  formData.append('file', file)

  const response = await http.post('/files/upload-image', formData, {
    params: { type },
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

  return response.data
}

export async function getGalleryImages(type = 'products') {
  const response = await http.get('/files/gallery-images', { params: { type } })
  return response.data
}